<template>
  <MainContent>
    <b-card>
      <nx-bform @submit="onSubmit">
        <h5>
          {{ $t("title") }}
        </h5>

        <!-- <nx-bform-server-errors name="server-errors" /> -->
        <div class="mb-2" style="color:#dc3545;font-size: 80%;margin-top: 0.25rem;">
          {{errorMsg}}
        </div>

        <LoginEmailFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.email"
          required
        />

        <CaptchaFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.captcha"
          @change-token="form.captchaToken = $event.token"
          required
        />

        <b-form-group label-cols="2">
          <b-button type="submit" variant="primary">{{
            $t("confirm")
          }}</b-button>
        </b-form-group>
      </nx-bform>
    </b-card>
  </MainContent>
</template>

<script>
import MainContent from "../../../components/main/MainContent";
import { UserApi } from "nx-libs";
import LoginEmailFormGroup from "@/forms/login/LoginEmailFormGroup";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";
import { translateResponseError } from "@/utils/translate-response-error";

export default {
  components: {
    MainContent,
    LoginEmailFormGroup,
    CaptchaFormGroup
  },
  data() {
    return {
      errorMsg: "",
      form: {
        email: "",
        captcha: "",
        captchaToken: ""
      }
    };
  },
  methods: {
    async onSubmit() {
      this.errorMsg = "";
      try {
        await UserApi.forgetUsername(this.form.email, this.form.captchaToken);
        this.$successToast(
          this.$t("messages.successTitle"),
          this.$t("messages.successMsg")
        );
      } 
      catch(ex) {
        if (ex.response && ex.response.data != null) {
          this.errorMsg = translateResponseError(this, ex.response.data);
        }
        throw ex;
      }
    }
  }
};
</script>

<style lang="scss"></style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/login.locale"></i18n>

<i18n src="@/locales/responseMsg.locale"></i18n>

<i18n>
{
  "en": {
    "title": "Recover @.lower:loginName",
    "messages": {
      "successTitle": "Email sent",
      "successMsg": "Please recover the @.low:loginName according to the email"
    }
  },
  "zh_hk": {
    "title": "恢復@:loginName",
     "messages": {
       "successTitle": "郵件已發送",
       "successMsg": "請根據電子郵件恢復@:loginName"
    }
  },
  "zh_cn": {
    "title": "恢复@:loginName",
      "messages": {
      "successTitle": "邮件已发送",
      "successMsg": "请根据电子邮件恢复@:loginName"
    }
  }
}
</i18n>
